// extracted by mini-css-extract-plugin
export default {"container":"PWAPopup_container__emoNI","bottom":"PWAPopup_bottom__94An6","iosIcon":"PWAPopup_iosIcon__goHI2"};